import React from "react";
import PropTypes from "prop-types";
import NoScore from "./NoScore";
import Score from "./Score";

/*
 * Orchestrates the display of a success score or an informational message if
 *    the student does not have a score
 *
 * @param termName - success score calculated for this term.
 * @param previousScore - success score from last week.
 * @param previousScoreDate - date success score was calculated last week
 * @param successScore - Score showing likelihood of student staying school or graduating in
 *           the next 12 months (lower the score - the higher the chances)
 * @param riskLevel - good, bad or 'meh' - based on the SUCCESS_SCORE_RANGE tenant configuratio
 * @returns {*}
 * @constructor
 */
const SuccessScoreView = ({termName, previousScore, previousScoreDate, successScore, riskLevel, opModelEnabled}) => {

    const getContent = (score) => {
        if (score)
            return (
                <Score
                    successScore={successScore}
                    termName={termName}
                    previousScore={previousScore}
                    previousScoreDate={previousScoreDate}
                    riskLevel={riskLevel}
                />
            )
        else return (<NoScore opModelEnabled={opModelEnabled}/>)
    }

    return (
        getContent(successScore)
    )
}


SuccessScoreView.propTypes = {
    successScore: PropTypes.number,
    termName: PropTypes.string,
    previousScore: PropTypes.number,
    previousScoreDate: PropTypes.string,
    riskLevel: PropTypes.string,
    opModelEnabled: PropTypes.bool
};

export default SuccessScoreView;
